import { useState } from "react";
import { emptySelection, toggleStageSelection } from "../domain/vinosSelection";

export function useVinoSelection() {
    const [selection, setSelection] = useState(emptySelection());

    const toggleStage = (id, stage) => {
        setSelection((prev) => {
            const { next, errorMsg } = toggleStageSelection(prev, id, stage);
            if (errorMsg) alert(errorMsg);
            return next;
        });
    };

    const clearSelection = () => setSelection(emptySelection());

    return { selection, toggleStage, clearSelection, setSelection };
}
